import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { JobPost } from "@/features/job-post/forms/job-post";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/jobs/post/edit/$id/",
)({
  component: CreateJobPostingPage,
});

function CreateJobPostingPage() {
  const { id } = Route.useParams();

  if (!id) {
    return <div>No job ID</div>;
  }

  return <JobPost jobId={id} />;
}
